import Benzinga from '@/assets/clients/clients-banner/benzinga.png';
import DearBrightly from '@/assets/clients/clients-banner/dear-brightly.png';
import Fayre from '@/assets/clients/clients-banner/fayre.png';
import Foodstuff from '@/assets/clients/clients-banner/foodstuff.png';
import Indio from '@/assets/clients/clients-banner/indio.png';
import Junction from '@/assets/clients/clients-banner/junction.png';
import Manduka from '@/assets/clients/clients-banner/manduka.png';
import Messyfm from '@/assets/clients/clients-banner/messyfm.png';
import ModernHealth from '@/assets/clients/clients-banner/modernhealth.png';
import Pegasus from '@/assets/clients/clients-banner/pegasus.png';
import Pulsar from '@/assets/clients/clients-banner/pulsar.png';
import Siren from '@/assets/clients/clients-banner/siren.png';
import Whitesky from '@/assets/clients/clients-banner/whitesky.png';
import Yogo from '@/assets/clients/clients-banner/yogo.png';

import type { ImgToClient } from '../type';

export const clientsBannerList = {
  benzinga: Benzinga,
  modernHealth: ModernHealth,
  whitesky: Whitesky,
  dearBrightly: DearBrightly,
  foodstuff: Foodstuff,
  indio: Indio,
  pegasus: Pegasus,
  yogo: Yogo,
  junction: Junction,
  manduka: Manduka,
  messyfm: Messyfm,
  fayre: Fayre,
  pulsar: Pulsar,
  siren: Siren,
} satisfies ImgToClient;
